/**
 * Mountpoint for post-flight data ingest from the operator.
 *
 * In the real workflow the operator's fleet software pushes captured photos
 * + flight-path data to the platform (via webhook + asset upload) once a
 * mission completes; the platform writes the result onto the corresponding
 * mission so DemoMissionMapLayer renders the photos / path on the map.
 *
 * The previous demo controller polled `mockDataFolderUrl` and pulled the
 * data from a Drive folder on mission completion. That auto-import path
 * was removed when the demo simulation was retired — the same data can
 * still be brought in via the user-triggered "Import mission data" modal
 * (DriveMissionImportModalDemo) which uses `importMockMissionData` for the
 * actual fetch + categorisation.
 *
 * Mounted at EditorPage level — returns null. Kept as a stub so the future
 * webhook handler has a clear place to live.
 */

export default function MissionAutoImportController() {
  // Future: subscribe to a post-flight webhook stream here and route
  // payloads through useDockDemoStore.getState().setMissionImportedData.
  return null;
}
